import React, {useEffect, useState, useContext} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import PdfPreviewModal from '../../global-components/PdfPreviewModal';

const BrochureHtml = (props) => {
    const {siteID, history} = props;

    const [state, setState] = useState({
        html: null,
        orientation: null,
        download_url: null,
    });

    useEffect(() => {
        getBrochureHtml();
    }, []);

    const getBrochureHtml = () => {

        axios({
            url: `/api/site/${siteID}/brochure-html`,
            method: 'GET',
        })
            .then((response) => {
                setState((prevState) => ({
                    ...prevState,
                    html: response.data.html,
                    download_url: response.data.download_url,
                    orientation: response.data.orientation,
                }));
            })
            .catch((error) => {
                console.error(error);
            });
    };


    return ReactDOM.createPortal(
        <>
            <style> {`.brochure-html-wrapper{ display: none; } .page-header{display: none;} .footer-container{display: none;}`}</style>
            <PdfPreviewModal
                isOpen={!!state.html}
                content={state.html}
                // downloadUrl={state.download_url}
                orientation={state.orientation}
                toggleModal={() => {

                    if (history.length > 3) {
                        history.goBack();
                    } else {
                        history.push('/');
                    }
                }}
            />
        </>
        , document.getElementById('portal-root')
    );

};

export default HeaderFooterHOC(BrochureHtml, 'brochure-html-wrapper');
